export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47')
];

export const server_loads = [];

export const dictionary = {
		"/": [14],
		"/(loginwrapper)/admin": [15,[2,3]],
		"/(loginwrapper)/admin/classes": [16,[2,3]],
		"/(loginwrapper)/admin/classes/new": [19,[2,3]],
		"/(loginwrapper)/admin/classes/[id]": [17,[2,3,4]],
		"/(loginwrapper)/admin/classes/[id]/students": [18,[2,3,4]],
		"/(loginwrapper)/admin/courses": [20,[2,3,5]],
		"/(loginwrapper)/admin/courses/new": [23,[2,3,5]],
		"/(loginwrapper)/admin/courses/[id]": [21,[2,3,5,6]],
		"/(loginwrapper)/admin/courses/[id]/skills": [22,[2,3,5,6]],
		"/(loginwrapper)/admin/reports": [24,[2,3]],
		"/(loginwrapper)/admin/users": [25,[2,3,7]],
		"/(loginwrapper)/admin/users/admins": [26,[2,3,7]],
		"/(loginwrapper)/admin/users/admins/[id]": [27,[2,3,7]],
		"/(loginwrapper)/admin/users/instructors": [28,[2,3,7]],
		"/(loginwrapper)/admin/users/instructors/[id]": [29,[2,3,7]],
		"/(loginwrapper)/admin/users/students": [30,[2,3,7]],
		"/(loginwrapper)/admin/users/students/[id]": [31,[2,3,7]],
		"/(loginwrapper)/classes": [32,[2,8]],
		"/(loginwrapper)/classes/[id]/(tablayout)": [33,[2,8,9,10]],
		"/(loginwrapper)/classes/[id]/animations": [38,[2,8,9]],
		"/(loginwrapper)/classes/[id]/(tablayout)/badges": [34,[2,8,9,10]],
		"/(loginwrapper)/classes/[id]/(tablayout)/badges/all": [36,[2,8,9,10]],
		"/(loginwrapper)/classes/[id]/(tablayout)/badges/[skillCategoryId]": [35,[2,8,9,10]],
		"/(loginwrapper)/classes/[id]/(tablayout)/leaderboard": [37,[2,8,9,10]],
		"/(loginwrapper)/classes/[id]/log": [39,[2,8,9,11]],
		"/(loginwrapper)/classes/[id]/log/submitted": [41,[2,8,9,11]],
		"/(loginwrapper)/classes/[id]/log/[skill_id]": [40,[2,8,9,11]],
		"/(loginwrapper)/instructors/classes": [42,[2,12]],
		"/(loginwrapper)/instructors/classes/[id]": [43,[2,12,13]],
		"/(loginwrapper)/instructors/classes/[id]/students": [44,[2,12,13]],
		"/(loginwrapper)/instructors/reports": [45,[2,12]],
		"/noaccess": [47],
		"/(loginwrapper)/onboarding": [46,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';